/* eslint-disable prefer-arrow/prefer-arrow-functions */
import React from 'react';
import { SelectedRepetitionChangeStream } from '../../../../data/change_streams/selected_repetition/selected_repetition_change_stream';
import { ISelectOption, ITestRepetition } from '../../../../data/types';
import { Select } from '../Select';

interface IRepetitionSelectProps {
  repetitions: ITestRepetition[];
  selectedRepetition: ITestRepetition | null;
  selectedRepetitionChangeStream: SelectedRepetitionChangeStream;
}

function toOption(label: string, value: number): ISelectOption<number> {
  return {
    label,
    value,
  };
}

function selectedToOption(
  options: Array<ISelectOption<number>>,
  rep?: ITestRepetition
): ISelectOption<number> | null {
  if (!rep) {
    return null;
  }
  const option = options.find(
    (mOption: ISelectOption<number>): boolean =>
      mOption.value === rep.repetitionNumber
  );
  return option ?? null;
}

export function RepetitionSelect(
  props: IRepetitionSelectProps
): React.ReactElement {
  const options = React.useMemo((): Array<ISelectOption<number>> => {
    const mOptions = [toOption('All Repetitions', 0)];
    for (const [index, _] of props?.repetitions?.entries() ?? []) {
      mOptions.push(toOption(`Repetition ${index + 1}`, index + 1));
    }
    return mOptions;
  }, [JSON.stringify(props?.repetitions)]);

  const onChange = (option: ISelectOption<number>): void => {
    if (option.value === 0) {
      props.selectedRepetitionChangeStream?.selectAverage();
    } else {
      props.selectedRepetitionChangeStream?.select(option.value);
    }
  };

  if (props?.selectedRepetitionChangeStream?.repetitions?.length > 0) {
    return (
      <div style={{ marginRight: '10px' }}>
        <Select
          options={options}
          value={
            selectedToOption(options, props.selectedRepetition) ?? options[0]
          }
          isDisabled={false}
          placeholder='Repetition'
          onChange={onChange}
          id={'input-select'}
          cache
        />
      </div>
    );
  } else {
    return <></>;
  }
}
